module.exports = __webpack_public_path__ + "static/img/material.89ead59a.svg";